import gql from 'graphql-tag';

export default gql`
    query GetDriversByRegion($input: GetDriversByRegionInput) {
        getDriversByRegion(input: $input) {
        id
        driverName
        trailerId
        trailerDescrip
        }
    }
`;
